import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer } from './rootReducer';

const dev = process.env.NODE_ENV === 'development';
const persistConfig = {
  key: 'root',
  storage,
  version: 1,
  blacklist: ['dialog', 'backdrop', 'message'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  devTools: dev
    ? {
        // Redux DevTools 설정 개선
        trace: true,
        traceLimit: 25,
      }
    : false,
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const persistor = persistStore(store);

// 개발 모드에서 Redux DevTools 연결 확인
if (dev) {
  console.log(
    '🔍 Redux DevTools 활성화 상태:',
    typeof store.getState === 'function' ? '✅ Store 생성됨' : '❌ Store 생성 실패',
  );
  console.log('📦 Redux Store:', store);
  console.log('🌍 NODE_ENV:', process.env.NODE_ENV);
  console.log('🔧 DevTools 설정:', dev ? '활성화됨' : '비활성화됨');
}

export default store;
